module.exports = __webpack_public_path__ + "img/symbol_9.62f80da3.png";